import * as React from "react"

const Fetching = ({ children, isFetching }: any) => {
  return !isFetching && <div>{children}</div>
}

export default Fetching
